import { render, staticRenderFns } from "./footImgCarousel.vue?vue&type=template&id=ff0b3ec2&scoped=true"
import script from "./footImgCarousel.vue?vue&type=script&lang=js"
export * from "./footImgCarousel.vue?vue&type=script&lang=js"
import style0 from "./footImgCarousel.vue?vue&type=style&index=0&id=ff0b3ec2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0b3ec2",
  null
  
)

export default component.exports